module.exports = __webpack_public_path__ + "img/Germantown_Grille@3x.86957b45.png";